import { Careers } from "@/types/codegen/Careers"

const flattenFilters = (filters?: Record<string, any>): Record<string, any> => {
  if (!filters) return {}

  const flattened: Record<string, any> = {}

  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return

    // Nếu value là object với operators như $eq, $in, etc.
    if (typeof value === "object" && !Array.isArray(value)) {
      Object.entries(value).forEach(([operator, operatorValue]) => {
        if (operatorValue !== undefined && operatorValue !== null) {
          flattened[`filters[${key}][${operator}]`] = operatorValue
        }
      })
    } else {
      // Mặc định dùng $eq
      flattened[`filters[${key}][$eq]`] = value
    }
  })

  return flattened
}

const getCareers = async (params: {
  filters?: Record<string, any>
  pagination?: {
    page?: number
    pageSize?: number
    pageCount?: number
    total?: number
  }
  locale?: string
  sort?: string | string[]
}) => {
  const queryParams: Record<string, any> = {
    populate: "*",
    sort: params.sort || "createdAt:desc",
    "pagination[page]": params.pagination?.page || 1,
    "pagination[pageSize]": params.pagination?.pageSize || 10,
    locale: params.locale || "vi",
    ...flattenFilters(params.filters),
  }

  const response = await new Careers().getCareers(queryParams)
  return response.data
}

export default getCareers
